import { z } from 'zod';

export const PushNotificationEventTypeSchema = z.enum([
  'notification_received',
  'notification_blocked',
  'notification_tapped',
  'notification_link_opened',
]);

export const PushNotificationEventSchema = z.object({
  id: z.string(),
  event_type: PushNotificationEventTypeSchema,
  delivery_id: z.string().nullable(),
  channel_id: z.string().optional(),
  occurred_at: z.number(),
  api_processed_at: z.number().optional(),
  analytics_processed_at: z.number().optional(),
});
